export default __webpack_public_path__ + "static/media/NotoSans-Regular.fa11626f.ttf";